<div class="ui-insight-cards tw:grid">
  @for (item of items(); track item.key) {
    <button class="ui-insight-card tw:grid tw:min-w-0 tw:text-left"
      type="button"
      [class.ui-insight-card--clickable]="item.clickable"
      [class.ui-insight-card--default]="(item.tone ?? 'default') === 'default'"
      [class.ui-insight-card--neutral]="item.tone === 'neutral'"
      [class.ui-insight-card--success]="item.tone === 'success'"
      [class.ui-insight-card--warning]="item.tone === 'warning'"
      [class.ui-insight-card--danger]="item.tone === 'danger'"
      [class.ui-insight-card--blue]="item.tone === 'blue'"
      [class.ui-insight-card--green]="item.tone === 'green'"
      [class.ui-insight-card--yellow]="item.tone === 'yellow'"
      [class.ui-insight-card--red]="item.tone === 'red'"
      [class.ui-insight-card--grey]="item.tone === 'grey'"
      [class.ui-insight-card--purple]="item.tone === 'purple'"
      [class.ui-insight-card--orange]="item.tone === 'orange'"
      [disabled]="!item.clickable"
      (click)="onCardClick(item)">
      <span class="ui-insight-card__header tw:items-center tw:inline-flex">
        @if (item.icon) {
          <ion-icon [name]="item.icon"></ion-icon>
        }
        <span>{{ item.titleKey | translate }}</span>
      </span>

      <strong class="ui-insight-card__value">{{ item.value }}</strong>

      @if (item.descriptionKey) {
        <span class="ui-insight-card__description">{{ item.descriptionKey | translate:item.descriptionParams }}</span>
      }

      @if (item.helperKey) {
        <span class="ui-insight-card__helper">{{ item.helperKey | translate:item.helperParams }}</span>
      }
    </button>
  }
</div>
